var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo, useRef, useState } from 'react';
import { InputNumber } from 'antd';
import EmptyComponent from 'components/EmptyComponent';
import DataTable from 'library/components/DataTable';
import { Chip, codeColumn, Mono, Muted, NameText, RowActions, RowButton, statusColumn } from 'library/components/DataTable/cells';
import ListScreen, { ListAddButton, ListSecondaryButton, listPager, usePagedRows } from 'library/components/ListScreen';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { instanceToPlain, plainToClass, plainToInstance } from 'class-transformer';
import dayjs from 'dayjs';
import { useQueryClient } from 'react-query';
import queries from 'constants/queries';
import { OrderEntity as OrderEntityResource, Package as PackageResource } from 'constants/resources';
import { OrderEntity, Package, PackagePrice } from 'models';
import OrderEntityDrawer from 'pages/Settings/drawers/OrderEntityDrawer';
import services from 'services';
var PACKAGE_UNIT_NAME = 'unit';
var typeTone = function (type) {
    if (type === 'lab')
        return 'is-sky';
    if (type === 'ray')
        return 'is-amber';
    if (type === 'procedure')
        return 'is-indigo';
    return 'is-violet';
};
var latestPackagePrice = function (prices, packageId) {
    if (!packageId || !(prices === null || prices === void 0 ? void 0 : prices.length))
        return undefined;
    return prices
        .filter(function (price) { return price.getPackageId() === packageId; })
        .sort(function (left, right) {
        var leftTime = dayjs(left.started_at).valueOf() || 0;
        var rightTime = dayjs(right.started_at).valueOf() || 0;
        if (leftTime !== rightTime)
            return rightTime - leftTime;
        return right.getId() - left.getId();
    })[0];
};
var OrderEntities = function (props) {
    var _a;
    var t = props.translate;
    var queryClient = useQueryClient();
    var orderEntityService = services.orderEntityService, packageService = services.packageService, packagePriceService = services.packagePriceService, permissionService = services.permissionService, unitMeasurementService = services.unitMeasurementService;
    var _b = useState(''), searchValue = _b[0], setSearchValue = _b[1];
    var _c = useState(false), drawerVisible = _c[0], setDrawerVisible = _c[1];
    var _d = useState(null), currentEntity = _d[0], setCurrentEntity = _d[1];
    var _e = useState(false), isEdit = _e[0], setIsEdit = _e[1];
    var _f = useState({}), prices = _f[0], setPrices = _f[1];
    var _g = useState(), savingId = _g[0], setSavingId = _g[1];
    var debounceRef = useRef(undefined);
    var canAdd = permissionService.hasPermissionToAdd(OrderEntityResource);
    var canEdit = permissionService.hasPermissionToEdit(OrderEntityResource);
    var canAddPrice = permissionService.hasPermissionToAdd(PackageResource);
    var showActions = canEdit || canAddPrice;
    var _h = orderEntityService.useOrderEntities(), orderEntities = _h.data, isLoading = _h.isLoading;
    var packagePrices = packagePriceService.usePackagePrices().data;
    var entities = orderEntities || [];
    var filtered = useMemo(function () {
        var query = searchValue.trim().toLowerCase();
        if (!query)
            return entities;
        return entities.filter(function (entity) {
            var haystack = [
                entity.getName(),
                entity.getCode(),
                t("orderEntities.entityTypes.".concat(entity.getEntityType())),
                t(entity.isEnabled() ? 'orderEntities.status.enabled' : 'orderEntities.status.disabled'),
                entity.getDescription()
            ]
                .join(' ')
                .toLowerCase();
            return haystack.includes(query);
        });
    }, [entities, searchValue, t]);
    var _j = usePagedRows(filtered), page = _j.page, setPage = _j.setPage, pages = _j.pages, from = _j.from, to = _j.to, pageRows = _j.pageRows;
    var unitMeasurements = unitMeasurementService.useUnitMeasurements().data;
    var createPackage = packageService.useCreateOrderEntityPackage().mutateAsync;
    var createPackagePrice = packagePriceService.useCreatePackagePrice().mutateAsync;
    var seededUnitId = (_a = (unitMeasurements || []).find(function (unit) { return unit.getName() === PACKAGE_UNIT_NAME; })) === null || _a === void 0 ? void 0 : _a.getId();
    var filledRows = entities.filter(function (entity) {
        var price = prices[entity.getId()];
        return price != null && price >= 1;
    });
    var onSearchValueChange = function (event) {
        var value = event.target.value;
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(function () {
            setPage(1);
            setSearchValue(value);
        }, 300);
    };
    var openCreate = function () {
        var entity = new OrderEntity();
        entity.setEnabled(true);
        entity.setEntityType('lab');
        setCurrentEntity(entity);
        setIsEdit(false);
        setDrawerVisible(true);
    };
    var openEdit = useCallback(function (entity) {
        setCurrentEntity(plainToInstance(OrderEntity, instanceToPlain(entity)));
        setIsEdit(true);
        setDrawerVisible(true);
    }, []);
    var onCloseDrawer = function () {
        setDrawerVisible(false);
        setCurrentEntity(null);
    };
    var clearPrice = useCallback(function (entityId) {
        setPrices(function (current) {
            var next = __assign({}, current);
            delete next[entityId];
            return next;
        });
    }, []);
    var saveEntityPrice = useCallback(function (entity, price) { return __awaiter(void 0, void 0, void 0, function () {
        var packageId, unitId, response, created, packagePrice;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    packageId = entity.getPackageId();
                    unitId = packageId ? entity.getPackageUnitMeasurementId() : seededUnitId;
                    if (!unitId)
                        return [2 /*return*/];
                    if (!!packageId) return [3 /*break*/, 2];
                    return [4 /*yield*/, createPackage({
                            name: "".concat(entity.getName(), " #").concat(entity.getId()),
                            description: entity.getDescription(),
                            entityId: entity.getId(),
                            unitMeasurementId: unitId
                        })];
                case 1:
                    response = _a.sent();
                    created = plainToClass(Package, response.data);
                    packageId = created.getId();
                    unitId = created.getUnitMeasurementId() || unitId;
                    _a.label = 2;
                case 2:
                    packagePrice = new PackagePrice();
                    packagePrice.setPackageId(packageId);
                    packagePrice.setQuantity(1);
                    packagePrice.setPrice(price);
                    packagePrice.setPriceType('total_price');
                    packagePrice.setUnitMeasurementId(unitId);
                    packagePrice.setIsEnabled(true);
                    packagePrice.started_at = dayjs().format('YYYY-MM-DD');
                    return [4 /*yield*/, createPackagePrice({
                            packagePrice: packagePrice,
                            successMessage: t('orderEntities.messages.priceCreated')
                        })];
                case 3:
                    _a.sent();
                    clearPrice(entity.getId());
                    return [2 /*return*/];
            }
        });
    }); }, [seededUnitId, createPackage, createPackagePrice, t, clearPrice]);
    var saveRow = useCallback(function (entity) { return __awaiter(void 0, void 0, void 0, function () {
        var price;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    price = prices[entity.getId()];
                    if (price == null || price < 1 || savingId != null)
                        return [2 /*return*/];
                    setSavingId(entity.getId());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, saveEntityPrice(entity, price)];
                case 2:
                    _a.sent();
                    queryClient.invalidateQueries(queries.orderEntities);
                    return [3 /*break*/, 4];
                case 3:
                    setSavingId(undefined);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [prices, savingId, saveEntityPrice, queryClient]);
    var saveAll = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _i, filledRows_1, entity, price;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!filledRows.length || savingId != null)
                        return [2 /*return*/];
                    setSavingId('all');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 6, 7]);
                    _i = 0, filledRows_1 = filledRows;
                    _a.label = 2;
                case 2:
                    if (!(_i < filledRows_1.length)) return [3 /*break*/, 5];
                    entity = filledRows_1[_i];
                    price = prices[entity.getId()];
                    if (price == null || price < 1)
                        return [3 /*break*/, 4];
                    return [4 /*yield*/, saveEntityPrice(entity, price)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    _i++;
                    return [3 /*break*/, 2];
                case 5:
                    queryClient.invalidateQueries(queries.orderEntities);
                    return [3 /*break*/, 7];
                case 6:
                    setSavingId(undefined);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var columns = useMemo(function () { return __spreadArray(__spreadArray([
        {
            key: 'name',
            title: t('orderEntities.table.name'),
            width: 'minmax(0, 1fr)',
            render: function (entity) { return (_jsxs("div", { className: "cidx-stack", children: [_jsx(NameText, { children: entity.getName() }), entity.getDescription() ? _jsx("span", { className: "cidx-stack__sub", children: entity.getDescription() }) : null] })); }
        },
        codeColumn({ key: 'code', title: t('orderEntities.table.code'), width: 'minmax(0, 1fr)', value: function (entity) { return entity.getCode(); } }),
        {
            key: 'type',
            title: t('orderEntities.table.entityType'),
            width: 'minmax(0, 1fr)',
            render: function (entity) { return (_jsx(Chip, { tone: typeTone(entity.getEntityType()), children: t("orderEntities.entityTypes.".concat(entity.getEntityType())) })); }
        },
        statusColumn({
            title: t('orderEntities.table.status'),
            width: 'minmax(0, 1fr)',
            active: function (entity) { return entity.isEnabled(); },
            activeLabel: t('orderEntities.status.enabled'),
            inactiveLabel: t('orderEntities.status.disabled')
        }),
        {
            key: 'price',
            title: t('orderEntities.table.price'),
            width: 'minmax(0, 1fr)',
            render: function (entity) {
                var latest = latestPackagePrice(packagePrices, entity.getPackageId());
                return latest
                    ? _jsx(Mono, { variant: "strong", children: t('common:price', { amount: latest.getPrice() }) })
                    : _jsx(Muted, {});
            }
        }
    ], (canAddPrice ? [{
            key: 'addPrice',
            title: t('orderEntities.actions.addPrice'),
            width: 'minmax(0, 1fr)',
            render: function (entity) { return (_jsx(InputNumber, { className: "cidx-price", min: 1, value: prices[entity.getId()], placeholder: t('orderEntities.table.price'), disabled: savingId != null, onChange: function (value) { return setPrices(function (current) {
                    var _a;
                    return (__assign(__assign({}, current), (_a = {}, _a[entity.getId()] = value == null ? null : Number(value), _a)));
                }); } })); }
        }] : []), true), (showActions ? [{
            key: 'actions',
            title: t('orderEntities.table.actions'),
            width: 'minmax(0, 1fr)',
            align: 'end',
            render: function (entity) {
                var price = prices[entity.getId()];
                return (_jsxs(RowActions, { children: [canAddPrice ? (_jsx(RowButton, { accent: true, disabled: savingId === entity.getId() ? false : price == null || price < 1 || savingId != null, onClick: function () { return saveRow(entity); }, children: t('orderEntities.actions.save') })) : null, canEdit ? _jsx(RowButton, { onClick: function () { return openEdit(entity); }, children: t('orderEntities.actions.edit') }) : null] }));
            }
        }] : []), true); }, [t, packagePrices, canAddPrice, prices, savingId, showActions, canEdit, saveRow, openEdit]);
    return (_jsxs(ListScreen, { title: t('orderEntities.title'), count: t('orderEntities.countBadge', { count: entities.length }), subtitle: t('orderEntities.subtitle'), actions: (_jsxs(_Fragment, { children: [canAddPrice && (_jsx(ListSecondaryButton, { label: t('orderEntities.actions.saveAll'), onClick: saveAll, disabled: !filledRows.length || savingId != null })), canAdd && _jsx(ListAddButton, { label: t('orderEntities.addEntity'), onClick: openCreate })] })), search: { placeholder: t('orderEntities.searchPlaceholder'), onChange: onSearchValueChange }, children: [_jsx(DataTable, { minWidth: "0px", loading: isLoading, rows: pageRows, rowKey: function (entity) { return entity.getId(); }, empty: _jsx(EmptyComponent, { description: t('orderEntities.empty') }), columns: columns, pager: listPager({
                    total: filtered.length,
                    page: page,
                    pages: pages,
                    meta: t('orderEntities.showingRange', { from: from, to: to, total: filtered.length }),
                    previous: t('orderEntities.previous'),
                    next: t('orderEntities.next'),
                    center: t('orderEntities.pageOf', { page: page, pages: pages }),
                    setPage: setPage
                }) }), _jsx(OrderEntityDrawer, { visiable: drawerVisible, onCloseDrawer: onCloseDrawer, orderEntity: currentEntity, isEdit: isEdit })] }));
};
export default localeTranslator(OrderEntities, 'settings');
